import LoginPage from "pages/login/Loadable";
import AssignmentsPage from "pages/assignments/Loadable";
import TermExamsPage from "pages/term-exams/Loadable";
import AnnouncementsPage from "pages/announcements/Loadable";
import LibraryPage from "pages/library/Loadable";
import MonthlySchedulePage from "pages/monthly-schedule/Loadable";
import LearnPage from "pages/learn/Loadable";
import ChangePaswordPage from "pages/change-password/Loadable";
import BuildTestPage from "pages/build-test/Loadable";
import QuestionMap from "pages/build-test/routes/test/question-map/Loadable";
import MiscellaneousPage from "pages/miscellaneous/Loadable";
import Error404 from "shared/templates/error/404";
import Error500 from "shared/templates/error/500";
import ErrorMainten from "shared/templates/error/under-mainten";
import PdfViewerComp from "shared/molecules/pdf-viewer";
import WarmUpTestPage from "pages/warm-up-delivery/Loadable";
import ActivitiesPage from "pages/activities/Loadable";
import HierarchiesPage from "pages/hierarchies/Loadable";
import CreateQuestionWithEditor from "pages/build-test/routes/question-grouping/create-question-with-editor/Loadable";
import { featureConfigConstants } from "app-component/helpers";
import ErrorPage from "shared/templates/error/403";
import GamesPage from "pages/games/Loadable";
export const publicRoutes = [
  {
    isPublic: true,
    exact: true,
    path: "/",
    component: LoginPage,
  },
  {
    isPublic: true,
    exact: true,
    path: "/login",
    component: LoginPage,
  },
  {
    isPublic: true,
    exact: true,
    path: "/403",
    component: ErrorPage,
  },
  {
    isPublic: true,
    exact: false,
    path: "/pdf-viewer/:id",
    component: PdfViewerComp,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_BUILD_TEST,
    isPublic: false,
    exact: false,
    path: "/question-map",
    component: QuestionMap,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_BUILD_TEST,
    isPublic: false,
    exact: true,
    path: "/question/:sourceType",
    component: CreateQuestionWithEditor,
  },
];

export const protectedRoutes = [
  {
    featureConfigKey: featureConfigConstants.DISABLE_ASSIGNMENTS,
    exact: false,
    path: "/assignments",
    component: AssignmentsPage,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_LIBRARY,
    exact: false,
    path: "/library",
    component: LibraryPage,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_MONTHLY_SCHEDULE,
    exact: false,
    path: "/monthly-schedule",
    component: MonthlySchedulePage,
  },
  {
    exact: true,
    path: "/400",
    component: Error404,
  },
  {
    exact: true,
    path: "/500",
    component: Error500,
  },
  {
    exact: true,
    path: "/mainten",
    component: ErrorMainten,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_TERM_EXAMS,
    exact: false,
    path: "/term-exams",
    component: TermExamsPage,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_ANNOUNCEMENTS,
    exact: false,
    path: "/announcements",
    component: AnnouncementsPage,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_LEARN,
    exact: false,
    path: "/learn",
    component: LearnPage,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_BUILD_TEST,
    exact: false,
    path: "/build-test",
    component: BuildTestPage,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_WARM_UP_DELIVERY,
    exact: false,
    path: "/warm-up-delivery",
    component: WarmUpTestPage,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_MISCELLANEOUS,
    exact: false,
    path: "/miscellaneous",
    component: MiscellaneousPage,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_ACTIVITIES,
    exact: false,
    path: "/activities",
    component: ActivitiesPage,
  },
  {
    exact: false,
    path: "/change-password",
    component: ChangePaswordPage,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_HIERARCHIES,
    exact: false,
    path: "/hierarchies",
    component: HierarchiesPage,
  },
  {
    featureConfigKey: featureConfigConstants.DISABLE_GAMES,
    exact: false,
    path: "/games",
    component: GamesPage,
  },
];
